import React from 'react';
import './Page.css';
import { useTranslation } from 'react-i18next';

function HowToPlay({ onBack }) {
  const { t } = useTranslation();

  return (
    <div className="page-container">
      <h1>{t('howto_title')}</h1>
      <p>{t('howto_intro')}</p>

      <h2>{t('howto_objective_title')}</h2>
      <p>{t('howto_objective_p1')}</p>

      <h2>{t('howto_controls_title')}</h2>
      <ul>
        <li>{t('howto_controls_item1')}</li>
        <li>{t('howto_controls_item2')}</li>
        <li>{t('howto_controls_item3')}</li>
      </ul>

      <h2>{t('howto_coins_title')}</h2>
      <ul>
        <li>{t('howto_coins_item1')}</li>
        <li>{t('howto_coins_item2')}</li>
      </ul>

      <h2>{t('howto_hints_title')}</h2>
      <p>{t('howto_hints_p1')}</p>

      <h2>{t('howto_progress_title')}</h2>
      <p>{t('howto_progress_p1')}</p>

      <button className="back-button" onClick={onBack}>{t('back_to_home')}</button>
    </div>
  );
}

export default HowToPlay;

